import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceControl: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceControl"><Path d="M5.5 15V9L2 12L5.5 15Z" fill="currentColor"/><Path d="M18.5 15V9L22 12L18.5 15Z" fill="currentColor"/><Path d="M12 4.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 7.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 7.5V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVoiceControl;
